import React from "react";
import { useParams } from "react-router";
import { getCalendarDay, PrayerHour } from "../../calendar/utils";
import { TweakProvider } from "../../utils/TweakProvider";
import { Compline } from "./compline/Compline";
import { Evensong } from "./Evensong";
import { Mattins } from "./Mattins";

export const PrayPage: React.FC<{}> = () => {
    const { year, month, date, hour } = useParams<{
        year: string;
        month: string;
        date: string;
        hour: PrayerHour;
    }>();

    const day = getCalendarDay(year, month, date, true);

    switch (hour) {
        case "mattins":
            return (
                <TweakProvider initialState={{}}>
                    <Mattins
                        day={day}
                        key={JSON.stringify(day)}
                        isToday={false}
                    />
                </TweakProvider>
            );
        case "evensong":
            return (
                <TweakProvider initialState={{}}>
                    <Evensong
                        day={day}
                        key={JSON.stringify(day)}
                        isToday={false}
                    />
                </TweakProvider>
            );
        case "compline":
            return (
                <TweakProvider initialState={{}}>
                    <Compline day={day} key={JSON.stringify(day)} />
                </TweakProvider>
            );
    }

    return <>Error: {hour} is not a valid hour.</>;
};
